import React from 'react';

export type ResizeHandle = 'nw' | 'n' | 'ne' | 'w' | 'e' | 'sw' | 's' | 'se';

interface ResizeHandlesProps {
  onResizeStart: (handle: ResizeHandle, e: React.MouseEvent) => void;
  isLocked?: boolean;
}

export const ResizeHandles: React.FC<ResizeHandlesProps> = ({
  onResizeStart,
  isLocked = false,
}) => {
  if (isLocked) return null;

  const handleStyle = (cursor: string): React.CSSProperties => ({
    position: 'absolute',
    width: 8,
    height: 8,
    backgroundColor: 'hsl(var(--selection))',
    border: '1px solid hsl(var(--background))',
    borderRadius: 2,
    cursor,
  });

  const handles: { key: ResizeHandle; style: React.CSSProperties; cursor: string }[] = [
    { key: 'nw', style: { top: -4, left: -4 }, cursor: 'nwse-resize' },
    { key: 'n', style: { top: -4, left: '50%', transform: 'translateX(-50%)' }, cursor: 'ns-resize' },
    { key: 'ne', style: { top: -4, right: -4 }, cursor: 'nesw-resize' },
    { key: 'w', style: { top: '50%', left: -4, transform: 'translateY(-50%)' }, cursor: 'ew-resize' },
    { key: 'e', style: { top: '50%', right: -4, transform: 'translateY(-50%)' }, cursor: 'ew-resize' },
    { key: 'sw', style: { bottom: -4, left: -4 }, cursor: 'nesw-resize' },
    { key: 's', style: { bottom: -4, left: '50%', transform: 'translateX(-50%)' }, cursor: 'ns-resize' },
    { key: 'se', style: { bottom: -4, right: -4 }, cursor: 'nwse-resize' },
  ];

  return (
    <>
      {handles.map(({ key, style, cursor }) => (
        <div
          key={key}
          style={{ ...handleStyle(cursor), ...style }}
          onMouseDown={(e) => {
            e.stopPropagation();
            onResizeStart(key, e);
          }}
        />
      ))}
    </>
  );
};
